module.exports = __webpack_public_path__ + "static/media/2fc3d2e3-1480-4e95-b944-7ab4d939f68b.ce1c9116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/2fc3d2e3-1480-4e95-b944-7ab4d939f68b.png
// module id = 1483
// module chunks = 0